import React, { useEffect, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "../OrderHistory.scss";
import "../OrderHistoryMobile.scss";
import { useAppContext } from "../../../../../Components/AppProvider";
import Modal from "../Modal/Modal";
import PaymentProcedure from "../Modal/ModalContent/PaymentProcedure";
import ToPayPartial from "./ToPayStatus/ToPayPartial";
import CancelForm from "../Modal/ModalContent/CancelForm/CancelForm";
import { setRedirect } from "../../../utils/redirect";
import { useNavigate } from "react-router-dom";

function UnpaidComponent() {
  const {
    unpaidOrderList,
    setOrderListUpdate,
    addressId,
    setCountListUpdateById,
    setUpdateOrderHistoryNav,
  } = useAppContext();

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState({});
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [singleOrderToPay, setSingleOrderToPay] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    setOrderListUpdate(true);
  }, []);
  const toggleExpand = (id) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const formatToMMDDYYYY = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  const [isModalOpen, setModalOpen] = useState(null);
  const handelPaymentModal = () => {
    //console.log("addressId:", addressId);
    if (addressId !== null) {
      setModalOpen("pay"); // open modal
    } else {
      alert("Please add a delivery address before proceeding to payment.");

      setRedirect(0, 1);
      setUpdateOrderHistoryNav(true);
    }
  };
  const handelCancelModal = () => {
    setModalOpen("cancel"); // open modal
  };
  // Handle Cancel Order
  const handleCancelOrder = async (reason) => {
    let ordersToCancel = [];

    if (singleOrderToPay) {
      // Single cancel mode
      ordersToCancel = [singleOrderToPay];
    } else {
      // Bulk cancel mode
      ordersToCancel = unpaidOrderList.filter((order) =>
        selectedOrders.includes(order.COI_ID)
      );
    }

    if (ordersToCancel.length === 0) return;

    const confirmCancel = window.confirm(
      `Are you sure you want to cancel ${ordersToCancel.length} order(s)?`
    );
    if (!confirmCancel) return;

    try {
      // 🔹 Example API request
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/orders/cancel`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ orders: ordersToCancel, reason }),
        }
      );

      if (!res.ok) throw new Error("Failed to cancel order(s)");

      alert("Order(s) cancelled successfully!");

      // 🔹 Reset selection and refresh list
      setSelectedOrders([]);
      setSingleOrderToPay(null);
      setOrderListUpdate(true);
      setCountListUpdateById((p) => !p);
    } catch (err) {
      console.error(err);
      alert("Failed to cancel order(s). Please try again.");
    }
  };

  // ✅ Handle individual checkbox
  const handleSelectOrder = (id) => {
    setSelectedOrders((prev) => {
      let newSelected;
      if (prev.includes(id)) {
        newSelected = prev.filter((orderId) => orderId !== id);
      } else {
        newSelected = [...prev, id];
      }

      // auto-update "Select All"
      setSelectAll(newSelected.length === filteredOrders.length);
      return newSelected;
    });
  };

  // ✅ Handle "Select All"
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedOrders([]);
      setSelectAll(false);
    } else {
      const allIds = filteredOrders.map((order) => order.COI_ID);
      setSelectedOrders(allIds);
      setSelectAll(true);
    }
  };
  const filteredOrders = unpaidOrderList.filter((order) => {
    const keyword = searchTerm.toLowerCase();

    // 1️⃣ Build a raw string from all order fields
    const orderString = Object.values(order)
      .map((val) => (val ? String(val).toLowerCase() : ""))
      .join(" ");

    // 2️⃣ Compute status label and message based on your conditions
    let statusLabel = "";
    let message = "";

    if (order.COI_Status === "Unpaid") {
      statusLabel = "TO PAY";
      message = "AWAITING DOWNPAYMENT";
    } else if (order.COI_Status === "Partial" && order.COI_Downpayment == 0) {
      statusLabel = "PENDING";
      message = "Downpayment Proof Submitted – Awaiting Verification";
    } else if (order.COI_Status === "Partial" && order.COI_Downpayment > 0) {
      statusLabel = "PARTIALLY PAID";
      message =
        "Down payment received. Full payment will be requested once the item is ready to ship.";
    } else if (order.COI_Status === "ToPayFull") {
      statusLabel = "TO PAY (FULLY)";
      message =
        "Your order is now ready. Please settle the remaining balance to proceed with shipping.";
    } else if (order.COI_Status === "Fully" && order.COI_Balance > 0) {
      statusLabel = "PENDING";
      message = "Full Payment Proof Submitted – Awaiting Verification";
    } else if (order.COI_Status === "Fully" && order.COI_Balance == 0) {
      statusLabel = "FULLY PAID";
      message =
        "Full payment received. Your order is now being processed for shipment.";
    } else if (
      order.COI_Status === "PaymentDeclined" &&
      order.COI_PaymentType === "partial"
    ) {
      statusLabel = "DECLINED";
      message =
        "Your Downpayment was declined because the receipt uploaded was invalid.";
    } else if (
      order.COI_Status === "PaymentDeclined" &&
      order.COI_PaymentType === "full"
    ) {
      statusLabel = "DECLINED";
      message =
        "Your Full payment was declined because the receipt uploaded was invalid.";
    }

    const computedString = `${statusLabel} ${message}`.toLowerCase();

    // 3️⃣ Include in filter if keyword matches either raw or computed string
    return orderString.includes(keyword) || computedString.includes(keyword);
  });

  return (
    <>
      <div className="oh-dp-container">
        <div className="oh-dp-header">
          <div className="oh-dp-header-wrapper">UNPAID ORDERS</div>
          <div className="oh-dp-button-wrapper ">
            <input
              type="text"
              placeholder="Search orders..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="oh-dp-downpayment">
          {/* ✅ Only show select all + actions if there are orders */}
          {filteredOrders.length > 0 && (
            <div className="dp-action">
              <div className="selectall-wrapper">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
                <span>SELECT ALL</span>
              </div>
              <div className="action-section">
                {selectedOrders.length > 0 && (
                  <>
                    <button
                      className="btn-pay"
                      onClick={() => {
                        setSingleOrderToPay(null);
                        handelPaymentModal();
                      }}
                    >
                      PAY ({selectedOrders.length})
                    </button>{" "}
                    <button
                      className="btn-pay"
                      onClick={() => {
                        setSingleOrderToPay(null);
                        handelCancelModal(); // 👈 use cancel function
                      }}
                    >
                      CANCEL ORDER ({selectedOrders.length})
                    </button>
                  </>
                )}
              </div>
            </div>
          )}

          {/* ✅ Show orders or "no data" message */}
          {filteredOrders.length > 0 ? (
            filteredOrders.map((order) =>
              order.COI_Status === "Unpaid" ? (
                <ToPayPartial
                  key={order.COI_ID}
                  order={order}
                  setSingleOrderToPay={setSingleOrderToPay}
                  handelPaymentModal={handelPaymentModal}
                  formatToMMDDYYYY={formatToMMDDYYYY}
                  selectedOrders={selectedOrders}
                  handleSelectOrder={handleSelectOrder}
                  handelCancelModal={handelCancelModal} // 👈 pass cancel handler
                />
              ) : (
                order.COI_Status
              )
            )
          ) : (
            <div className="no-orders-message">
              <p>No unpaid orders found.</p>
            </div>
          )}
        </div>
      </div>
      <Modal
        isModalOpen={isModalOpen}
        onClose={() => {
          setModalOpen(null);
        }}
      >
        {isModalOpen === "pay" ? (
          <PaymentProcedure
            onClose={() => setModalOpen(null)}
            selectedOrders={
              singleOrderToPay
                ? [singleOrderToPay] // ✅ single order mode
                : unpaidOrderList.filter((order) =>
                    selectedOrders.includes(order.COI_ID)
                  ) // ✅ bulk mode
            }
            setSelectedOrders={setSelectedOrders}
            setOrderListUpdate={setOrderListUpdate}
            hasPartial={false}
          />
        ) : (
          <CancelForm
            onClose={() => setModalOpen(null)}
            selectedOrders={
              singleOrderToPay
                ? [singleOrderToPay] // ✅ single order mode
                : unpaidOrderList.filter((order) =>
                    selectedOrders.includes(order.COI_ID)
                  ) // ✅ bulk mode
            }
            setSelectedOrders={setSelectedOrders}
            setOrderListUpdate={setOrderListUpdate}
            hasPartial={false}
            handleCancelOrder={handleCancelOrder}
          />
        )}
      </Modal>
    </>
  );
}

export default UnpaidComponent;
